import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n/i18n';
import {
    TextField, Button, Grid, IconButton,
    Dialog, DialogContent, DialogTitle
} from '@material-ui/core';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    addFieldManager, getStates,
    setInitialState
} from '../../actions/AdministrationActions';
import { getLocalGov } from '../../actions/FarmRegistarActions';
import { getUser } from '../../utils/CommonFunctions';


export class AddFieldManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fmObj: {}
        };
    }

    async componentDidMount() {
        const { getStates, getLocalGov } = this.props;
        getStates();
        let user = await getUser();
        if (user) {
            getLocalGov(user.id_opstina);
            const { fmObj } = this.state;
            let obj = Object.assign({}, fmObj);
            obj.id_opstina = user.id_opstina;
            this.setState({
                fmObj: obj
            })
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.fmPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('fmPostingFailed');
        }
    }

    handleChangeValue = name => event => {
        const { fmObj } = this.state;
        let obj = Object.assign({}, fmObj);
        obj[name] = event.target.value;
        this.setState({ fmObj: obj });
    };

    addFieldManager() {
        const { fmObj } = this.state;
        const { addFieldManager } = this.props;
        if (fmObj.kontakt_mejl &&
            fmObj.id_katastarska_opstina &&
            fmObj.id_opstina &&
            fmObj.ime &&
            fmObj.prezime &&
            fmObj.username &&
            fmObj.password) {
            addFieldManager(
                fmObj
            )
        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }


    render() {
        const { localGoverments, localGovermentsFetching, states, statesFetching, add, handleClose } = this.props;
        const { fmObj } = this.state;
        let localGovermentsArray = [];
        if (localGoverments && !localGovermentsFetching) {
            localGovermentsArray = localGoverments.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        let statesArray = [];
        if (states && !statesFetching) {
            statesArray = states.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>
                <Dialog
                    open={add}
                    onClose={handleClose}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{i18n.t('Add field manager')}
                        <IconButton onClick={handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-zonal">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <TextField
                                    label={i18n.t('First name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={fmObj.ime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('ime')}
                                />
                                <TextField
                                    label={i18n.t('Last name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={fmObj.prezime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('prezime')}
                                />
                                <TextField
                                    label={i18n.t('Username')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={fmObj.username}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('username')}
                                />
                                <TextField
                                    label={i18n.t('Password')}
                                    type="password"
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('password')}
                                />
                                <TextField
                                    select
                                    label={i18n.t('State')}
                                    value={fmObj.id_opstina}
                                    required
                                    disabled
                                    onChange={this.handleChangeValue('id_opstina')}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    margin="normal"
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                >

                                    <option value='' />
                                    {statesArray}
                                </TextField>

                                <TextField
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    label={i18n.t('Local government')}
                                    value={fmObj.id_katastarska_opstina}
                                    required
                                    onChange={this.handleChangeValue('id_katastarska_opstina')}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    margin="normal"
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                >

                                    <option value='' />
                                    {localGovermentsArray}
                                </TextField>

                                <TextField
                                    label={i18n.t('Address')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={fmObj.ulica_i_broj}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('ulica_i_broj')}
                                />

                                <TextField
                                    label={i18n.t('Zip code')}
                                    value={fmObj.postanski_broj}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('postanski_broj')}
                                />

                                <TextField
                                    label={i18n.t('Email')}
                                    value={fmObj.kontakt_mejl}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_mejl')}
                                />

                                <TextField
                                    label={i18n.t('Phone')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={fmObj.kontakt_telefon}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_telefon')}
                                />
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#61a50e', color: 'white' }}
                                        onClick={() => this.addFieldManager()}
                                    >
                                        {i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        states: state.administrationReducer.states,
        statesFetching: state.administrationReducer.statesFetching,
        fmObj: state.administrationReducer.fmObj,
        statesFetchingFailed: state.administrationReducer.statesFetchingFailed,
        fmPostingFailed: state.administrationReducer.fmPostingFailed,
        localGoverments: state.farmRegistarReducer.localGoverments,
        localGovermentsFetching: state.farmRegistarReducer.localGovermentsFetching,
        localGovermentsFetchingFailed: state.farmRegistarReducer.localGovermentsFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getStates: () => dispatch(getStates()),
        getLocalGov: (id_state) => dispatch(getLocalGov(id_state)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addFieldManager: (fmObj) => dispatch(addFieldManager(fmObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFieldManager)